/**This component comes into action when registered user wants to create and add details in the about section of the fundraiser */

import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { forkJoin } from 'rxjs';
import { AccountService } from 'src/app/pages/account/services/account.service';
import { NotificationService } from 'src/app/shared/services/notification.service';
import { Tools } from 'src/utilities/tools';
import { FundraiserService } from '../../../../services/fundraiser.service';
import { MediaService } from '../../../../services/media.service';
import { MatIconModule } from '@angular/material/icon';
import { FundraiserMediaEditComponent } from '../../../shared/fundraiser-media-edit/fundraiser-media-edit.component';
import { QuillEditorComponent } from '../../../../../../shared/components/quill-editor/quill-editor.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FlexModule } from '@angular/flex-layout/flex';
import { ExtendedModule } from '@angular/flex-layout/extended';
import { NgClass, NgIf } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'app-create-about',
    templateUrl: './create-about.component.html',
    standalone: true,
    imports: [MatButtonModule, MatDialogModule, NgClass, ExtendedModule, FlexModule, NgIf, MatProgressSpinnerModule, QuillEditorComponent, FundraiserMediaEditComponent, MatIconModule]
})
export class CreateAboutComponent implements OnInit {
	isSave = false;
	newAbout: any = { content: '', imageListOperation: [] };
	mediaList: any;
	// maxLengthCheck: any;
	allTextCheck: boolean = false;
	loadingText: boolean = false;

	constructor(
		public _mediaService: MediaService,
		public _fundraiserService: FundraiserService,
		public notificationService: NotificationService,
		public _accountService: AccountService,
		@Inject(MAT_DIALOG_DATA) public data: { currentFundraiser: any },
		public dialogRef: MatDialogRef<CreateAboutComponent>
	) {}

	ngOnInit(): void {
		this.mediaList = this._mediaService.getMediaList(
			this.data?.currentFundraiser?.image_list
		);
	}

	changeAboutContent(event: any) {
		this.newAbout['content'] = event;
	}
	addAboutMedia(event: any) {
		this.newAbout?.imageListOperation?.push({ add: event });
	}

	allCheck(event: boolean) {
		this.allTextCheck = event;
	}

	saveAboutContentAndMedia() {
		this.isSave = true;
		let observableSourceList: any[] = [];

		// Load DOMPurify
		//const DOMPurify = require('dompurify');

		// Helper function to process content
		const processContent = (content: string): string => {
			if (!content) {
				return '';
			}

			// Replace <ul>, <ol>, and <li> tags
			const replacedContent = content
				.replace(
					/<ul>(.*?)<\/ul>/gs,
					(match: string, innerContent: string): string => {
						return innerContent.replace(
							/<li>(.*?)<\/li>/g,
							'&#8226;&nbsp;$1<br>' // Replace <li> inside <ul> with bullet points
						);
					}
				)
				.replace(
					/<ol>(.*?)<\/ol>/gs,
					(match: string, innerContent: string): string => {
						let index = 1; // Start numbering from 1
						return innerContent.replace(
							/<li>(.*?)<\/li>/g,
							(_, item: string): string => {
								return `${index++}.&nbsp;${item}<br>`; // Replace <li> inside <ol> with numbered list
							}
						);
					}
				);

			// Sanitize the replaced content
			//return DOMPurify.sanitize(replacedContent);
			return replacedContent;
		};

		// Handle media if image list exists
		if (this.newAbout?.imageListOperation?.length) {
			let mediaObservableSourceList = this.getMediaSourceList();
			observableSourceList = observableSourceList.concat(
				mediaObservableSourceList
			);
		}

		// Process content if it exists
		if (this.newAbout?.content) {
			let contentBody = this.getContentBodyObject();
			let contentTranslationBody = this.getContentTranslationBodyObject();

			// Process and sanitize content
			contentBody.content = processContent(this.newAbout.content);

			// Process and sanitize content translations
			contentTranslationBody.content = processContent(this.newAbout.content);

			// Push the modified content into observable list
			observableSourceList.push(
				this._fundraiserService.updateFundraiserInformation(contentBody)
			);
			observableSourceList.push(
				this._fundraiserService.saveUpdatesTranslation(contentTranslationBody)
			);
		}

		// Check if translations exist and handle accordingly
		if (!Object.keys(this.data?.currentFundraiser?.translations)?.length) {
			this._fundraiserService
				.createFundraiserInformationTranslation(
					this.getInitTranslationBodyObject()
				)
				.subscribe((res) => {
					forkJoin(observableSourceList).subscribe(
						(results) => {
							this.isSave = false;
							this.dialogRef.close(true);
						},
						(err: any) => {
							this.notificationService.openNotification(
								$localize`:@@create_about_errorAdding_notification:There was an error Adding Fundraiser About`,
								'close',
								'error'
							);
							this.isSave = false;
						}
					);
				});
		} else {
			forkJoin(observableSourceList).subscribe(
				(results) => {
					this.isSave = false;
					this.dialogRef.close(true);
				},
				(err: any) => {
					this.notificationService.openNotification(
						$localize`:@@create_about_errorAdding_notification:There was an error Adding Fundraiser About`,
						'close',
						'error'
					);
					this.isSave = false;
				}
			);
		}
	}

	getMediaSourceList() {
		let observableSourceList: any = [];
		this.newAbout?.imageListOperation.forEach(
			(operation: any, index: number) => {
				let mediaBody = new FormData();
				if (operation?.add) {
					mediaBody = this.getAddMediaBodyObject(operation?.add);
					observableSourceList.push(
						this._mediaService.saveAboutMedia(mediaBody)
					);
				}
			}
		);
		return observableSourceList;
	}
	getAddMediaBodyObject(media: any) {
		let mediaBody = new FormData();
		mediaBody.append(
			'fundraising_local',
			this.data?.currentFundraiser?.id.toString()
		);
		mediaBody.append('text', 'carousel');
		mediaBody.append('delete', 'false');
		mediaBody.append('id', 'null');
		if (media?.image) {
			mediaBody.append('image', media.image);
		}
		if (media?.videoUrl) {
			mediaBody.append('video_url', media.videoUrl);
		}
		return mediaBody;
	}

	getContentBodyObject() {
		return {
			id: this.data?.currentFundraiser?.id,
			content: this.newAbout?.content,
			description: this.escapeHtml(this.newAbout?.content),
			language_code: this.data?.currentFundraiser?.language_code,
		};
	}
	getInitTranslationBodyObject() {
		return {
			fundraising_local_id: this.data?.currentFundraiser?.id,
			title: this.data?.currentFundraiser?.title,
			is_auto: true,
			content: ' ',
			description: ' ',
			language_code: this._accountService.getLocaleId(),
			created_at: new Date().getTime(),
			updated_at: new Date().getTime(),
			currency_code: 'eur',
		};
	}
	getContentTranslationBodyObject() {
		return {
			fundraising_local_id: this.data?.currentFundraiser?.id,
			title: this.data?.currentFundraiser?.title,
			description: this.escapeHtml(this.newAbout?.content),
			content: this.newAbout?.content,
			updated_at: new Date().getTime(),
			is_auto: true,
			language_code: this.data?.currentFundraiser?.language_code,
		};
	}

	escapeHtml(string_with_html: any) {
		/** *.(remove any tags).(remove double space) */
		return string_with_html
			?.replace(/<[^>]*>/g, ' ')
			?.replace(/\s\s+/g, ' ')
			?.trim();
	}
	onCloseClick() {
		this.dialogRef.close();
	}
	handlePasteDetected(loader: boolean) {
		this.loadingText = loader;
	}
}
